<template>
  <div
    class="listBookAreaContainer"
    :class="[baseClass, activeClass]"
    @click="setFreeSearchListActive(false)"
  >
    <bookListHandle
      class="top"
      v-show="!showList"
      txt="v"
      @click="toggleShowFreeSearchList"
    />
    <div>
      <searchBarContainer class="top-search-bar" />
      <headerBookListContainer @checkall="checkAll" />
    </div>
    <listBookContainer />
    <listStatus />
  </div>
</template>

<script>
import searchBarContainer from "@/components/listBookArea/searchBarContainer/searchBarContainer.vue";
import headerBookListContainer from "@/components/listBookArea/headerBookListContainer/headerBookListContainer.vue";
import listBookContainer from "@/components/listBookArea/listContentContainer/listBookContainer.vue";
import bookListHandle from "@/components/listBookArea/freeSearchBarContainer/bookListHandle.vue";
import listStatus from "@/components/listBookArea/listContentContainer/listStatus.vue";
import { mapState, mapActions } from "vuex";
import { createFreeSearchBookListStore } from "@/store_pinia";
export default {
  components: {
    searchBarContainer,
    headerBookListContainer,
    listBookContainer,
    bookListHandle,
    listStatus,
  },
  computed: {
    freeSearchBookListStore() {
      return createFreeSearchBookListStore("main", false);
    },
    showList() {
      return this.freeSearchBookListStore?.showList || false;
    },
    active() {
      return this.freeSearchBookListStore?.active ? "active" : "";
    },
    activeClass() {
      return !this.active ? "active" : "";
    },
    baseClass() {
      return "listBookAreaContainer";
    },
  },
  methods: {
    ...mapActions("bookList", ["checkAllBooks"]),
    toggleShowFreeSearchList() {
      this.freeSearchBookListStore.toggleShowFreeSearchList();
    },
    setFreeSearchListActive(val) {
      this.freeSearchBookListStore.active = val;
    },
    checkAll(check) {
      this.checkAllBooks({ check, search: this.searchTxt });
    },
  },
};
</script>

<style lang="scss" scoped>
.listBookAreaContainer {
  width: 100%;
  height: calc(100% - 11px);

  display: flex;
  flex-direction: column;
  &::before {
    content: "";
    display: block;
  }
  .top-search-bar {
    background-color: #d4d4d4;
  }
}
</style>
